/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree, DEFAULT_SAVED_SEARCH_TREE_SORT } from '../helpers/savedSearches';

const customId = 'getSavedSearchesFailed';

export const getSavedSearches = createAsyncThunk(
  'savedSearches/getSavedSearches',
  async (_, { getState, extra: { sdk, Logger, Toast } }) => {
    const userId = getState().user._id;
    const sortType = getState().user?.searchesSortType || DEFAULT_SAVED_SEARCH_TREE_SORT;

    try {
      const { data: savedSearches } = await sdk.savedSearches.getAll();
      return { savedSearches, userId, sortType };
    } catch (error) {
      Logger.log('UI', 'ToastSavedSearchesNotLoaded');
      Toast(
        'Saved searches has not loaded. Try refreshing the page to see them.',
        {
          toastId: customId,
          autoClose: false,
          type: 'error',
        },
      );
      Logger.error(new Error('Can not get saved searches'), { error }, [
        'GetSavedSearchesFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      getSavedSearches.pending,
      (state) => {
        state.isLoaded = false;
        state.isLoading = true;
        state.tree = null;
        state.all = [];
        state.error = null;
      },
    )
    .addCase(
      getSavedSearches.fulfilled,
      (state, { payload: { savedSearches, userId, sortType } }) => {
        state.isLoaded = true;
        state.isLoading = false;
        state.error = null;
        state.treeSortType = sortType || DEFAULT_SAVED_SEARCH_TREE_SORT;
        state.tree = makeTree(savedSearches?.nodes, userId, '', state.treeSortType);
        state.all = savedSearches.nodes;
        // Stash the current user's id so optimistic-update reducers (which
        // run synchronously, before any payload userId is available) can
        // re-derive the tree without losing the favorites filter.
        state.userId = userId;
      },
    )
    .addCase(
      getSavedSearches.rejected,
      (state, { error }) => {
        state.isLoaded = false;
        state.isLoading = false;
        state.error = error;
        state.tree = null;
        state.all = [];
      },
    );
};
